module.exports = __webpack_public_path__ + "0779a62b6a91a3c1621898d49b06b7fd.fbx";